/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UboDeclarationStatusResource = {
    Created: 'CREATED',
    ValidationAsked: 'VALIDATION_ASKED',
    Validated: 'VALIDATED',
    Refused: 'REFUSED',
    Incomplete: 'INCOMPLETE'
} as const;
export type UboDeclarationStatusResource = typeof UboDeclarationStatusResource[keyof typeof UboDeclarationStatusResource];


export function instanceOfUboDeclarationStatusResource(value: any): boolean {
    for (const key in UboDeclarationStatusResource) {
        if (Object.prototype.hasOwnProperty.call(UboDeclarationStatusResource, key)) {
            // @ts-ignore
            if (UboDeclarationStatusResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UboDeclarationStatusResourceFromJSON(json: any): UboDeclarationStatusResource {
    return UboDeclarationStatusResourceFromJSONTyped(json, false);
}

export function UboDeclarationStatusResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UboDeclarationStatusResource {
    return json as UboDeclarationStatusResource;
}

export function UboDeclarationStatusResourceToJSON(value?: UboDeclarationStatusResource | null): any {
    return value as any;
}

